package diana.soleil.design.iraniancanadienbazzar.core.designsystem.component

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.style.TextOverflow
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme

/**
 * News/story card for horizontal carousels (Home "News" row): image on top, headline + optional
 * teaser below. Copy-free — caller passes localized [title]/[teaser]. Null [imageUrl] renders the
 * on-brand placeholder with [fallbackIcon].
 */
@Composable
fun NewsCard(
    title: String,
    modifier: Modifier = Modifier,
    teaser: String? = null,
    imageUrl: String? = null,
    onClick: (() -> Unit)? = null,
    fallbackIcon: String = "newspaper",
) {
    AppCard(modifier = modifier.width(AppTheme.sizes.featuredCardWidth), onClick = onClick) {
        Column {
            BusinessCover(
                imageUrl = imageUrl,
                iconName = fallbackIcon,
                modifier = Modifier
                    .fillMaxWidth()
                    .aspectRatio(16f / 9f)
                    .clip(AppTheme.shapes.card),
            )
            Column(modifier = Modifier.padding(AppTheme.spacing.lg)) {
                Text(
                    text = title,
                    style = AppTheme.typography.headlineMd,
                    color = AppTheme.colors.onSurface,
                    maxLines = 2,
                    overflow = TextOverflow.Ellipsis,
                )
                if (!teaser.isNullOrBlank()) {
                    Text(
                        text = teaser,
                        style = AppTheme.typography.bodySm,
                        color = AppTheme.colors.onSurfaceVariant,
                        maxLines = 2,
                        overflow = TextOverflow.Ellipsis,
                        modifier = Modifier.padding(top = AppTheme.spacing.xxs),
                    )
                }
            }
        }
    }
}
